import { loansClient } from "../api/axiosClient";
import { LOANS_ENDPOINTS } from "../api/endpoints";

export const JOURNEY_OUTCOMES = {
  SHOW_FLDG_APPLY: "SHOW_FLDG_APPLY",
  REDIRECT_FLDG: "REDIRECT_FLDG",
  SHOW_BL_APPLY: "SHOW_BL_APPLY",
  SHOW_BL_STAGE_PAGE: "SHOW_BL_STAGE_PAGE",
  SHOW_FLDG_THANKS: "SHOW_FLDG_THANKS",
};

export const JOURNEY_TYPES = {
  UBL_FLDG: "ubl_fldg",
  UBL: "ubl",
};

/**
 * Call USER_JOURNEY_DECISION. Always returns the envelope (or null on network failure).
 * Callers must guard optional keys on data before use.
 */
export async function fetchUserJourneyDecision(glid, ak) {
  if (!glid || !ak) return null;

  try {
    const formData = new FormData();
    formData.append("glid", glid);
    formData.append("ak", ak);

    const res = await loansClient.post(LOANS_ENDPOINTS.USER_JOURNEY_DECISION, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      validateStatus: () => true,
    });

    return res?.data ?? res ?? null;
  } catch (error) {
    console.error("userJourneyDecision failed:", error);
    return null;
  }
}

/** True when envelope has a routable data.outcome (incl. FLDG_LINK_ERROR with data). */
export function hasUsableJourneyOutcome(envelope) {
  const data = envelope?.data;
  if (!data || typeof data !== "object") return false;
  if (!Object.prototype.hasOwnProperty.call(data, "outcome")) return false;
  return Boolean(data.outcome);
}

export function isFldgLinkError(envelope) {
  return envelope?.error?.type === "FLDG_LINK_ERROR";
}

export function getJourneyTypeFromData(data) {
  if (!data || typeof data !== "object") return "";
  if (!Object.prototype.hasOwnProperty.call(data, "journey_type")) return "";
  return data.journey_type || "";
}
